export default "__VITE_ASSET__SU28TFxP__"